import React from 'react';
import { List } from 'semantic-ui-react';

import mapConnection from '../../../utils/connectionMapper';
import FixedIcon from '../../FixedIcon';
import documentErrorTypes from '../../../utils/documentErrorTypes';
import { findDocumentType } from '../../../utils/documentTypes';

const ErrorsList = ({ claim }) => {
  const claimsPassengerTickets = claim.claimsPassengerTicketConnection
    ? mapConnection(claim.claimsPassengerTicketConnection)
    : [];
  return claimsPassengerTickets.map(cpt => {
    const { documentsConnection, passengerTicket } = cpt || '';
    const documents = documentsConnection
      ? mapConnection(documentsConnection).filter(
          doc => doc.conflictsWithClaim
        )
      : [];
    const { id, passengerFirstName, passengerLastName } =
      passengerTicket || '';
    return documents.length > 0 ? (
      <List key={id}>
        {passengerFirstName} {passengerLastName}
        {documents.map(
          (doc, i) =>
            doc &&
            doc.conflictsWithClaim.map((conflict, j) => {
              const errorType = JSON.parse(conflict)[0];
              return (
                <List.Item key={`${i}:${j}`}>
                  <FixedIcon name="warning circle" color="red" />
                  <List.Content style={{ color: 'red' }}>
                    {(errorType in documentErrorTypes
                      ? documentErrorTypes[errorType]
                      : errorType) +
                      (doc.type && ' in ' + findDocumentType(doc.type).text)}
                  </List.Content>
                </List.Item>
              );
            })
        )}
      </List>
    ) : null;
  });
};

export default ErrorsList;



// WEBPACK FOOTER //
// ./src/component/tasks/HandleUnsuccessfulLOAValidationTask/ErrorsList.js